import React from 'react'
import Header from '../Components/Header/Header'
import SiteFooter from '../Components/Footer/SiteFooter'
import HomeHeader from '../Components/Header/HomeHeader';


function PublicLayout({ page }) {

  // const [isLogin, setIsLogin] = useState(false)
  // const [pageLoaded, setPageLoaded] = useState(false)
  // let token;
  // // let token = getToken()

  // useEffect(() => {
  //   if (localStorage.getItem("token") != null) {
  //     token = localStorage.getItem('token');
  //     setIsLogin(true)
  //   } else if (sessionStorage.getItem('token') != null) {
  //     token = sessionStorage.getItem('token')
  //     setIsLogin(true)
  //   } else {
  //     setIsLogin(false)
  //   }
  //   setPageLoaded(true)
  // }, [])

  return (
    <>
      <div className={`main-wrapper ${window.location.pathname === '/buy-now' ? "but-now-page" : ""}`}>
        {window.location.pathname === '/' ? <HomeHeader /> : <Header />}
        {page}
        <SiteFooter />
      </div>
    </>
  )
}

export default PublicLayout